import AddIcon from '@mui/icons-material/Add'
import RefreshIcon from '@mui/icons-material/Refresh'
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  Typography
} from '@mui/material'
import { FC, useContext, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FieldsFilter, Grid, InputSearch } from 'src/components/UI'
import { filtersActions } from 'src/ducks/actions'
// import { getContractorsFilter } from 'src/ducks/filters/selector'
// import { ContractorsFilterType } from 'src/ducks/filters/types'
import { ContractorsContext } from '../context'
import { MODAL_TYPE } from '../context/types'
import useStyles from './styles'
import { ToolbarProps } from './types'

const Toolbar: FC<ToolbarProps> = ({
}) => {
  const styles = useStyles()

  const dispatch = useDispatch()

  // const contractorsFilter = useSelector(getContractorsFilter())

  const { dispatch: dispatchContext } = useContext(ContractorsContext)

  // const search = useMemo(() => contractorsFilter.search || '', [contractorsFilter])

  const handleNewContractor = () => {
    dispatchContext({
      type: 'SET_VALUE',
      payload: { attr: 'modalType', value: MODAL_TYPE.CREATE },
    })
    dispatchContext({
      type: 'SET_VALUE',
      payload: { attr: 'modalOpen', value: true },
    })
  }

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Typography className={styles.title} width="fit-content">
        Contractor Management
      </Typography>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-end"
        className={styles.headerContainer}
        marginTop={1}
        gap={2}
      >
        {/* <Grid
          container
          alignItems="flex-end"
          justifyContent="center"
          spacing={2}
        >
          <Grid item flex={1}>
            <InputSearch
              // label="Search for Contractors:"
              placeholder="Search Contractors"
              onChange={(value) => updateContractorsFilter({ search: value })}
              value={search}
              sx={{ width: '100%' }}
            />
          </Grid>
          <Grid item>
            <FormControlLabel
              label="Institutional"
              control={
                <Checkbox
                  onChange={() =>
                    updateContractorsFilter({
                      institutional: !contractorsFilter.institutional,
                    })
                  }
                  checked={!!contractorsFilter.institutional}
                />
              }
            />
          </Grid>
          <Grid item>
            <IconButton
              style={{
                marginLeft: '10px',
                marginTop: '5px',
              }}
              onClick={fetchData}
            >
              <RefreshIcon />
            </IconButton>
          </Grid>
        </Grid> */}
        <Box display="flex" gap="12px">
          {/* <FieldsFilter
            flexColumn
            handleChange={handleAffiliatesChange}
            inputText="All Affiliates:"
            popupLabel=""
            options={selectedAffiliates}
            renderAsInput
            contentAlign="left"
            variant="body1"
            sx={{ width: '358px', height: '37px', flex: '1' }}
            searchable={true}
            popoverSx={{ width: '378px !important' }}
            searchFieldPlaceholder="Contractor Name"
            allSelection={false}
          /> */}

          <Button
            onClick={handleNewContractor}
            variant="contained"
            color="primary"
            startIcon={
              <AddIcon
                color="inherit"
                fontSize="inherit"
                style={{ height: '12px' }}
              />
            }
          >
            New Contractor
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default Toolbar
